module.exports = __webpack_public_path__ + "img/home_icon2@2x.9e9bb384.png";